const COOKIES_PREFIX = '_lmnd';
// If a user interacted with the cookie banner
const COOKIE_BANNER_ACCEPTED = '_lmnd_cookie_banner_accepted';
// Should activate tracking
const ENABLE_COOKIES = '_lmnd_enable_cookies';
// Which types of cookies are enabled
const COOKIE_TYPES_ENABLED = '_lmnd_cookie_types_enabled';
// New UUID
const CN_UUID_NEW = '_lmnd_uuid_2021';
const GEOGRAPHY_COOKIE = '_lmnd_geography';
// User id
const CIOID = '_cioid';
const CN_LANGUAGE = 'language';
const CN_REGION = 'region';
const AGENTS_COOKIE_NAME = 'agents_jwt';
const SHARED_AUTH = '_lmnd_shared_auth';
const GEO = 'geo';
const THEME = 'theme';

// AB test variation for home bundle section - not really a cookie. keeping it here because the const is used throughout the app
const CN_HOME_BUNDLE_SECTION_DISPLAY = '_lmnd_home_bundle_section_display';

// AB test page variant cookie
const VARIANT_COOKIE_NAME = 'lp_variant';

export {
  COOKIES_PREFIX,
  ENABLE_COOKIES,
  COOKIE_BANNER_ACCEPTED,
  COOKIE_TYPES_ENABLED,
  CN_LANGUAGE,
  CN_REGION,
  CN_UUID_NEW,
  AGENTS_COOKIE_NAME,
  SHARED_AUTH,
  CN_HOME_BUNDLE_SECTION_DISPLAY,
  GEOGRAPHY_COOKIE,
  CIOID,
  GEO,
  VARIANT_COOKIE_NAME,
  THEME,
};
